import { FormularioContato } from '../features/sac';

function SacPage() {
  return (
    <div style={{ height: '100vh', overflow: 'auto' }}>
      <FormularioContato />
    </div>
  );
}

export default SacPage;
